export enum READER_PROGRESS_SOURCE {
    userReaderProgress = 'user-reader-progress',
    localReaderProgress = 'local-reader-progress',
}
